"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/api/college/index");
var _newsMenhu = require("@/api/news/newsMenhu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {},
  data: function data() {
    return {
      tabList: [],
      // majorList: this.$store.getters.wIndustryCategory,
      searchForm: {
        majorName: '',
        courseName: ''
      }
    };
  },
  created: function created() {
    this.getNewsTypeList();
    // console.log(this.majorList);
    // this.getcategoriesList()
  },
  methods: {
    //获取新闻分类
    getNewsTypeList: function getNewsTypeList() {
      var _this = this;
      (0, _newsMenhu.newsTypeList)().then(function (res) {
        _this.tabList = res.rows;
      });
    },
    //专业大类
    getcategoriesList: function getcategoriesList() {
      var _this2 = this;
      (0, _index.categoriesList)({
        pageNum: 1,
        pageSize: 99999,
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.majorList = res.data.list;
        }
      });
    },
    handleSearch: function handleSearch() {
      console.log('searchForm', this.searchForm);
      this.$emit('toSsearch', this.searchForm);
    }
  }
};